<template>
  <div class="current-cost-dialog-container">
    <div class="data-containers">
      <div class="data-container">
        <h3>adatok</h3>
        <div class="data-container-rows">
          <div class="data-container-row">
            <h4>bank</h4>
            <span>K&H Bank</span>
          </div>
          <div class="data-container-row">
            <h4>bankkártya</h4>
            <span>{{ accountInfo.package === 'PREMIUM' ? 'K&H Mastercard arany bankkártya' : 'K&H Mastercard betéti érintőkártya'}}</span>
          </div>
        </div>
      </div>

      <div class="data-container">
        <h3>banki díjak</h3>
        <div class="data-container-rows">
          <div class="data-container-double-row">
            <div class="data-container-row">
              <h4>kártyadíj</h4>
              <span>{{ balanceFormatter(accountInfo.cardFee) }}</span>
            </div>
            <div class="data-container-row">
              <h4>számladíj</h4>
              <span>{{ balanceFormatter(accountInfo.accountFee) }}</span>
            </div>
          </div>
          <div class="data-container-double-row">
            <div class="data-container-row">
              <h4>átutalások díja</h4>
              <span>{{ balanceFormatter(accountInfo.transferFees) }}</span>
            </div>
            <div class="data-container-row">
              <h4>állandó átutalások díja</h4>
              <span>{{ balanceFormatter(accountInfo.recurringTransferFee) }}</span>
            </div>
          </div>
          <div class="data-container-double-row">
            <div class="data-container-row">
              <h4>csoportos beszedés díja</h4>
              <span>{{ balanceFormatter(accountInfo.groupDirectDebitFee) }}</span>
            </div>
            <div class="data-container-row">
              <h4>készpénzfelvétel díja</h4>
              <span>{{ balanceFormatter(accountInfo.cashWithdrawalFee) }}</span>
            </div>
          </div>
          <div class="data-container-row">
            <h4>egyéb díjak</h4>
            <span>{{ balanceFormatter(accountInfo.otherFees) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="recalculate-button-container">
      <div class="recalculate-button" @click="$emit('recalculate')">
        módosítom a kalkulációt
      </div>
    </div>
  </div>
</template>

<script>
import "./_vpd-kh-cost.scss";

export default {
  name: "vpd-kh-cost",
  props: {
    accountInfo: {
      type: Object,
    }
  },
  computed: {
    balanceFormatter() {
      return (amount, currency = 'HUF') =>
        new Intl.NumberFormat('hu-HU', { style: 'currency', currency, maximumFractionDigits: 0 })
          .format(Number(amount))
    },
  },
};
</script>
